document.addEventListener( "DOMContentLoaded", () => {

	document.querySelectorAll( ".wp-block-video--icon" ).forEach( ( block ) => {

		block.addEventListener( "click", () => {

			const video = block.querySelector( "video" );
			const overlay = block.querySelector( ".wp-block-video__overlay" );
			if ( video ) {

				video.play();
				if ( overlay ) {

					overlay.style.display = "none";

				}
				block.classList.add( "is-played" );

			}

		} );

	} );

} );
